import { createIcon } from './icon';

export const TimeIcon = createIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.86667 11.1334L10.8 10.2L8.33333 7.73336V4.66669H7V8.26669L9.86667 11.1334ZM7.66667 14.6667C6.74444 14.6667 5.87778 14.4917 5.06667 14.1417C4.25556 13.7917 3.55 13.3167 2.95 12.7167C2.35 12.1167 1.875 11.4112 1.525 10.6C1.175 9.78891 1 8.92225 1 8.00002C1 7.0778 1.175 6.21113 1.525 5.40002C1.875 4.58891 2.35 3.88336 2.95 3.28336C3.55 2.68336 4.25556 2.20836 5.06667 1.85836C5.87778 1.50836 6.74444 1.33336 7.66667 1.33336C8.58889 1.33336 9.45556 1.50836 10.2667 1.85836C11.0778 2.20836 11.7833 2.68336 12.3833 3.28336C12.9833 3.88336 13.4583 4.58891 13.8083 5.40002C14.1583 6.21113 14.3333 7.0778 14.3333 8.00002C14.3333 8.92225 14.1583 9.78891 13.8083 10.6C13.4583 11.4112 12.9833 12.1167 12.3833 12.7167C11.7833 13.3167 11.0778 13.7917 10.2667 14.1417C9.45556 14.4917 8.58889 14.6667 7.66667 14.6667ZM7.66667 13.3334C9.14444 13.3334 10.4028 12.8139 11.4417 11.775C12.4806 10.7361 13 9.4778 13 8.00002C13 6.52224 12.4806 5.26391 11.4417 4.22502C10.4028 3.18613 9.14444 2.66669 7.66667 2.66669C6.18889 2.66669 4.93056 3.18613 3.89167 4.22502C2.85278 5.26391 2.33333 6.52224 2.33333 8.00002C2.33333 9.4778 2.85278 10.7361 3.89167 11.775C4.93056 12.8139 6.18889 13.3334 7.66667 13.3334Z"
      fill="currentColor"
    />
  </svg>,
  'TimeIcon'
);
